import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const goToken: string | null = localStorage.getItem('goToken');
        // const router: Router;

        if (goToken && environment.goApiURL && request.url.indexOf(environment.goApiURL) === 0) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + goToken) });
        }

        // PHP API: JWT bertanda tangan dikirim terpisah dari Authorization (base64 user).
        // Dibaca per request supaya ikut berubah setelah login / setPerusahaan.
        if (environment.apiURL && request.url.indexOf(environment.apiURL) === 0) {
            request = request.clone({ headers: request.headers.set('X-Access-Token', goToken || '') });
        }

        if (!request.headers.has('Content-Type') &&!(request.body instanceof FormData)) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                let data = {};
                data = {
                    reason: error && error.error && error.error.reason ? error.error.reason : '',
                    status: error.status
                };
                // 401: token expired / invalid signature (humanis-be-go returns
                // 401 for JWT expiry; humanis-api keeps returning 200 with
                // status:error so we still need 403 too for older paths).
                // Both end the session.
                if (error.status == 401 || error.status == 403) {
                    localStorage.removeItem('userDetail');
                    localStorage.removeItem('token');
                    localStorage.removeItem('goToken');
                    window.location.href = '/account/login';
                }
                //  this.router.navigate(['/account/login']);

                // this.errorDialogService.openDialog(data);
                // window.location.reload();
                return throwError(error);
            }));
            
    }
}
